import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Col, Modal, Row, Spin, Typography, message } from 'antd';
import { withRouter } from 'react-router-dom';
import { getAllUserProfileData, saveResume, getParsedResumeData } from '../../../services/Dashboard';
import ProfileActions from '../profile/Profile.actions';
import { ApiConstant, PageConstant } from '../../../constants';
import { debounce, get, isEqual } from 'lodash';
import { getVettedSkillsStats, getWorkHistoriesStats } from '../../util/profileCheckUtil';
import { pushLog2DV2LogServer } from '../../../services/logging';
import queryString from 'query-string';
import { GB_FLAGS, withLDFlagsFromBackend } from '../../services/launchDarkly';
import { redirectToFastrack } from '../Fastrack/Fastrack';
import * as onboardingService from "../../../services/Onboarding";

function withFinalizeResumeV2Service(Component) {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }
  /**
   * Jobs services
   */
  class FinalizeResumeV2Service extends React.Component {
    state = {
      activeForm: '',
      loading: true,
      saved: false,
      focusProject: null,
      requiredActions: [],
      unmappedResumeData: '',
      baseSkills: [],
      sugg: {
        PersonalInformation: [],
        WorkHistory: [],
        SideProjects: [],
        Education: [],
        AdditionalInformation: []
      },
      completed: {
        PersonalInformation: true,
        WorkHistory: true,
        SideProjects: true,
        Education: true,
        AdditionalInformation: true,
        languages: true,
      },
      PersonalInformation: {},
      WorkHistory: [],
      SideProjects: [],
      Education: [],
      Publications: [],
      Certifications: [],
      CloudCertificationsTypes: [],
      skillInfo: {
        all_skills: [],
        passed_skills: [],
        skills_inprogress: []
      },
      languages: {
        proficiencyTypes: [],
        proficiencyLevels: [],
        languagesList: [],
        developerLanguageProficiencies: [],
      },
    };

    constructor (props) {
      super(props);
      this.saveDebounce = debounce(() => this.save(null, true), 2000);
    }

    saveDebounce = () => { };

    componentDidMount () {
      localStorage.removeItem('RESUME_BUILDER_COMPLETED');
      Promise.all([
        axios.get(ApiConstant.BASE_URL + ApiConstant.GET_DEVELOPER_SKILL_INFO)
          .then(result => get(result, 'data.data'))
          .then(skillInfo => {
            this.setState({ skillInfo });
          })
          .catch(console.error),
        this.loadCloudCertificationList(),
        this.getVetsmithFlowData(),
        this.loadProficiencyTypesAndLevels(),
        this.loadLanguages(),
        this.loadDeveloperLanguageProficiencies(),
        this.getBaseAllSkillList()
        // this.getInfoParsedFromResumeData()

      ])
        .finally(() => {
          this.loadData(['PersonalInformation', 'WorkHistory', 'SideProjects', 'Education', 'Publications', 'Certifications', 'CloudCertifications'], this.checkURLToOpenSection);
        })
        .catch(console.error);
      window.addEventListener('vetting-notification-click', this.checkURLToOpenSection);
    }

    componentWillUnmount () {
      window.removeEventListener('vetting-notification-click', this.checkURLToOpenSection);
      let data = null;
      try {
        data = JSON.parse(localStorage.getItem('RESUME_BUILDER_COMPLETED'));
      } catch (e) { }
      if (!data) return;

      if (data.incompleteSections && data.incompleteSections.length === 0) {
        pushLog2DV2LogServer.info('RESUME_BUILDER_EXIT_PAGE', 'RESUME_BUILDER_EXIT_PAGE', {}, { completed: true, ...data });
      } else if (data.incompleteSections && data.incompleteSections.length > 0) {
        pushLog2DV2LogServer.info('RESUME_BUILDER_EXIT_PAGE', 'RESUME_BUILDER_EXIT_PAGE', {}, { completed: false, ...data });
      }
    }

    setCompleted = (section, value) => {
      this.setState(s => ({ ...s, completed: { ...s.completed, [section]: !!value } }));
    }

    isWorkHistorySectionCompleted = (entries) => {
      const empFields = ['position', 'company', 'start_month', 'start_year', 'employment_type'];
      const projFields = ['project_name', 'details', 'outcome', 'start_month', 'start_year'];
      const extra_fields = ['end_month', 'end_year'];

      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];
        const empFieldsPresent = [...empFields, ...(entry.end_year !== 0 ? extra_fields : [])].every(field => entry[field]);
        if (!empFieldsPresent) return false;

        const projects = (Array.isArray(entry.projects) && entry.projects) || [];

        for (let j = 0; j < projects.length; j++) {
          const project = projects[j];
          const projectFieldsPresent = [...projFields, ...(project.end_year !== 0 ? extra_fields : [])].every(field => project[field]);
          if (!projectFieldsPresent) return false;
        }
      }
      return true;
    }

    checkCompletedSections = () => {
      const { WorkHistory, Education, skillInfo } = this.state;
      const { vettedSkillsStats } = getVettedSkillsStats(skillInfo.all_skills, WorkHistory);
      const skillsMismatchInYOE = vettedSkillsStats.filter(elm => elm.skill.score > elm.skillYOE);

      this.deleteRequiredActionByGroup('skillsMismatchInYOE');
      if (skillsMismatchInYOE.length) {
        const content = skillsMismatchInYOE.map(elm => {
          const diff = elm.skill.score * 12 - elm.skillMOE;
          const years = Math.floor(diff / 12);
          const months = diff % 12;
          return <li key={elm.skill.id}><b>{elm.skill_name} : </b> Add {years > 0 ? (years + ' year' + (years > 1 ? 's' : '')) : null} {months > 0 ? (months + ' month' + (months > 1 ? 's' : '')) : null} </li>;
        });
        this.addRequiredAction('skillsMismatchInYOE', {
          id: 'skillsMismatchInYOE',
          group: 'skillsMismatchInYOE',
          title: 'Mismatch in years of declared experience in profile section & project durations for the following skills',
          content: <ul>{content}</ul>
        });
      }
      const completeSections = [];
      const incompleteSections = [];
      const completed = {
        PersonalInformation: true,
        WorkHistory: true,
        SideProjects: true,
        Education: true,
        AdditionalInformation: true,
        languages: true,
      };

      const totalDetails = getWorkHistoriesStats(WorkHistory);
      if (totalDetails < 500) {
        incompleteSections.push('500 words in the Work history');
      } else {
        completeSections.push('500 words in the Work history');
      }

      if (!WorkHistory || !WorkHistory.length) {
        completed.WorkHistory = false;
        incompleteSections.push('WorkHistory');
      } else {
        if (this.isWorkHistorySectionCompleted(WorkHistory)) {
          completeSections.push('WorkHistory');
        } else {
          completed.WorkHistory = false;
          incompleteSections.push('WorkHistory');
        }
      }

      // if (!SideProjects || !SideProjects.length) {
      //   completed.SideProjects = false;
      //   incompleteSections.push('SideProjects');
      // } else {
      //   completeSections.push('WorkHistory');
      // }

      if (!Education || !Education.length) {
        completed.Education = false;
        incompleteSections.push('Education');
      } else {
        completeSections.push('Education');
      }

      // if (!Publications || !Publications.length) {
      //   completed.AdditionalInformation = false;
      //   incompleteSections.push('Publications');
      // } else {
      //   completeSections.push('Publications');
      // }

      // if (!Certifications || !Certifications.length) {
      //   completed.AdditionalInformation = false;
      //   incompleteSections.push('Certifications');
      // } else {
      //   completeSections.push('Certifications');
      // }

      this.setState({ completed });
      return { completeSections, incompleteSections };
    }

    loadData = (list, callback, isAutoSave) => {
      if (isAutoSave) {
        this.validateSkillsDetails();
        const sectionStatus = this.checkCompletedSections();
        if (callback) callback(sectionStatus);
        return;
      }
      getAllUserProfileData()
        .then(result => result.data)
        .then(result => result.data)
        .then(result => {
          const data = {};
          if (list.includes('PersonalInformation')) {
            data.PersonalInformation = result.personal_info || {};
          }

          if (list.includes('WorkHistory')) {
            data.WorkHistory = result.experience_info || [];
          }

          if (list.includes('SideProjects')) {
            data.SideProjects = result.projects_info || [];
          }

          if (list.includes('Education')) {
            data.Education = result.education_info || [];
          }

          if (list.includes('Publications')) {
            data.Publications = result.publication_info || [];
          }

          if (list.includes('Certifications')) {
            data.Certifications = result.certification_info || [];
          }

          if (list.includes('CloudCertifications')) {
            data.CloudCertifications = result.cloud_certification_info || [];
          }

          this.setState(data, () => {
            this.validateSkillsDetails();
            const sectionStatus = this.checkCompletedSections();
            if (callback) callback(sectionStatus);
          });
        })
        .catch(console.error)
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    getAllNotEnoughExpSkills = () => {
      let notEnoughExp = localStorage.getItem('notEnoughExp') || '';
      notEnoughExp = notEnoughExp ? (JSON.parse(notEnoughExp) || []) : [];
      notEnoughExp = Array.isArray(notEnoughExp) ? notEnoughExp : [];
      return notEnoughExp;
    }

    hideSkillFromRequiredAction = () => {
      const { currentSkill } = this.state;
      if (!currentSkill || !currentSkill.skill) return;
      const { skill } = currentSkill;
      const notEnoughExp = this.getAllNotEnoughExpSkills();
      if (!notEnoughExp.includes(skill.id)) notEnoughExp.push(skill.id);
      localStorage.setItem('notEnoughExp', JSON.stringify(notEnoughExp));
      this.saveNotEnoughExpSkill(skill.id);
      this.validateSkillsDetails();
    }

    saveNotEnoughExpSkill = (skill_id) => {
      axios.post(`${ApiConstant.BASE_URL}${ApiConstant.SAVE_NOT_ENOUGH_SKILL_EXP}`, { skill_id })
        .catch(console.error);
    }

    validateSkillsDetails = () => {
      const { skillInfo, WorkHistory } = this.state;
      const completedSkillsInt = (skillInfo.passed_skills || []).map((skill) => parseInt(skill, 10));
      const vettedSkills = (skillInfo.all_skills || []).filter(skill => !skill.not_enough_experience && completedSkillsInt.includes(parseInt(skill.skill_id, 10)));
      const { vettedSkillsStats } = getVettedSkillsStats(vettedSkills, WorkHistory);
      const inSufficientSkillDetails = vettedSkillsStats.filter(vSkill => (vSkill.skillMentionsCount < 3 || vSkill.skillYOE < 2));
      const totalDetails = getWorkHistoriesStats(WorkHistory);
      this.deleteRequiredActionByGroup('WorkHistory');
      if (totalDetails < 500) {
        this.addRequiredAction('WorkHistory', {
          id: 'totalDetails',
          group: 'WorkHistory',
          title: 'Add at least 500 words in the Work history section',
          content: <p>Current: {totalDetails} / 500 words</p>
        });
      }
      if (inSufficientSkillDetails.length) {
        const notEnoughExp = this.getAllNotEnoughExpSkills();
        inSufficientSkillDetails.filter(elm => !notEnoughExp.includes(elm.skill.id)).forEach(elm => {
          const content = [];
          if (elm.skillMentionsCount < 3) {
            content.push(`You've mentioned this skill ${elm.skillMentionsCount}/3 times, add it ${(3 - elm.skillMentionsCount)} time${(3 - elm.skillMentionsCount) > 1 ? 's' : ''} more in project description.`);
          }

          if (elm.skillYOE < 2) {
            content.push(`Current skill experience in project duration is ${elm.skillMOE} month${elm.skillMOE > 1 ? 's' : ''}, minimum 2 years required.`);
          }

          let editContent = null;
          if (elm.skillMentionsList.length) {
            editContent = (
              <div>
                <div><b>{elm.skill_name} is tagged in {elm.skillMentionsList.length > 1 ? 'these projects:' : 'this project'}</b></div>
                <ul style={{ padding: '5px 0 0 20px' }}>
                  {elm.skillMentionsList.map(item => {
                    return (
                      <li key={item.project_id}>
                        <div className="skillMentionsItem">
                          <div className="skillMentionsItem-title">
                            {item.title}
                          </div>
                          <div className="skillMentionsItem-editlink" onClick={e => this.setState({ focusProject: item })}>
                            Edit
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          } else {
            editContent = <div>{elm.skill_name} is not tagged in any project!</div>;
          }

          const years = Math.floor(elm.skillMOE / 12);
          const months = elm.skillMOE % 12;
          this.addRequiredAction('WorkHistory', {
            id: elm.skill_name,
            group: 'WorkHistory',
            title: 'Add enough experience for ' + elm.skill_name,
            content: (
              <div>
                <ul style={{ paddingLeft: 20 }}>
                  {elm.skillMentionsCount < 3 ? <li>Mentioned: <b> {elm.skillMentionsCount} / 3 times</b></li> : null}
                  {elm.skillMOE < 24 ? <li>Experience: <b> {years > 0 ? (years + ' year' + (years > 1 ? 's' : '')) : null} {months > 0 ? (months + ' month' + (months > 1 ? 's' : '')) : null} {(years === 0 && months === 0) ? 0 : null} / 2 years</b></li> : null}
                </ul>
                {elm.skillYOE < 2 ? <Button className="btnnotenoughexp" onClick={() => this.setState({ showWarning: true, currentSkill: elm })}>I have less than 2 years of experience in {elm.skill_name}</Button> : null}
              </div>
            ),
            editContent
          });
        });
      }
    }

    getInfoParsedFromResumeData = async () => {
      try {
        const response = await axios.get(`${ApiConstant.BASE_URL}dashboard/get-unmapped-resume-data`);
        if (response.data.data) {
          this.setState({
            unmappedResumeData: response.data.data
          });
        }
      } catch (e) {
        console.error(e);
      }
    }

    getBaseAllSkillList = async () => {
      try {
        const response = await axios.post(`${ApiConstant.BASE_URL}common/`, {
          action: 'GET_BASE_ALL_SKILL_LIST',
          get_canonical_skills: true
        });
        if (response.data.success) {
          this.setState({ baseSkills: response.data.result });
        }
      } catch (e) {
        console.error(e);
      }
    };

    loadCloudCertificationList = async () => {
      try {
        axios.get(ApiConstant.BASE_URL + ApiConstant.GET_CLOUD_CERTIFICATION_LIST)
          .then(result => get(result, 'data.result'))
          .then(CloudCertificationsTypes => {
            const cloudCertificationDropDownValues = CloudCertificationsTypes.map(item => {
              return {
                label: item.certification_name,
                value: item.certification_type_id,
                referenceRequired: item.certification_reference_required
              };
            });
            this.setState({ CloudCertificationsTypes: cloudCertificationDropDownValues });
          });
      } catch (e) {
        console.error(e);
      }
    }

    loadProficiencyTypesAndLevels = async () => {
      try {
        axios.get(ApiConstant.BASE_URL + ApiConstant.FETCH_LANGUAGE_PROFICIENCY_TYPE_AND_LEVELS)
          .then(result => get(result, 'data.data'))
          .then(({ proficiencyLevels, proficiencyTypes }) => {
            const mappedProficiencyLevels = proficiencyLevels.map(item => {
              return {
                value: item.id,
                label: item.name,
              }
            });

            this.setState({
              languages: {
                ...this.state.languages,
                proficiencyLevels: mappedProficiencyLevels,
                proficiencyTypes
              }
            });
          });
      } catch (e) {
        console.error(e);
      }
    }

    loadLanguages = async () => {
      try {
        onboardingService.getAllLanguages().then(result => get(result, 'data.data'))
          .then(({ languages }) => {
            const mappedLanguages = languages.map(item => {
              return {
                value: item.id,
                label: item.name,
                disabled: false
              }
            });

            this.setState({
              languages: {
                ...this.state.languages,
                languagesList: mappedLanguages
              }
            });
          });
      } catch (e) {
        console.error(e);
      }
    }

    loadDeveloperLanguageProficiencies = async () => {
      try {
        this.setState({ loading: true });
        onboardingService.getDeveloperLanguageProficiencies().then(result => get(result, 'data.data'))
          .then(({ developerLanguageProficiencies }) => {

            const mappedDeveloperLanguageProficiencies = developerLanguageProficiencies.map((item) => {
              return {
                renderId: `temp-${Math.random()}`,
                ...item,
              }
            });

            this.setState({
              languages: {
                ...this.state.languages,
                developerLanguageProficiencies: mappedDeveloperLanguageProficiencies,
              }
            });
          }).finally(() => {
            this.setState({ loading: false });
          });
      } catch (e) {
        console.error(e);
      }
    }

    removeDeveloperLanguage = async (data) => {
      try {
        const response = await onboardingService.removeAllLanguages(data);
        if (response.status === 204) {
          message.success('Language has been deleted successfully', 2);
        } else {
          message.error('Error: unable to remove language', 2);
        }
      } catch (e) {
        message.error('Error: unable to remove language', 2);
        console.error(e);
      }
    };

    saveDeveloperLanguageProficiencies = async (developerLanguageProficiencies, showSuccessAlert) => {
      try {
        const response = await onboardingService.saveDeveloperLanguageProficiencies({ developerLanguageProficiencies});
        if (response.status === 201) {
          if(showSuccessAlert){
            message.success('Languages have been added successfully', 2);
          }
        } else {
          message.error('Error: unable to add languages', 2);
        }
      } catch (e) {
        message.error('Error: unable to add languages', 2);
        console.error(e);
      }
    }

    getProficiencyTypes = () => {
      return this.state.languages.proficiencyTypes;
    }

    getProficiencyLevels = () => {
      return this.state.languages.proficiencyLevels;
    }

    getLanguagesList = () => {
      return this.state.languages.languagesList;
    }

    getDeveloperLanguageProficiencies = () => {
      return this.state.languages.developerLanguageProficiencies;
    }

    getCloudCertificationTypes = () => {
      return this.state.CloudCertificationsTypes;
    }

    addSugg = (name, sugg) => {
      this.setState(s => {
        const list = (s.sugg[name] || []).filter(({ id }) => id !== sugg.id);
        return { sugg: { ...s.sugg, [name]: [...list, sugg] } };
      });
    }

    deleteSugg = (name, id) => {
      this.setState(s => {
        const list = (s.sugg[name] || []).filter((sugg) => id !== sugg.id);
        return { sugg: { ...s.sugg, [name]: [...list] } };
      });
    }

    addRequiredAction = (group, item) => {
      this.setState(s => {
        const list = (s.requiredActions || []).filter(({ id }) => id !== item.id);
        return { requiredActions: [...list, { ...item, group }] };
      });
    }

    deleteRequiredAction = (id) => {
      this.setState(s => {
        const list = (s.requiredActions || []).filter((item) => id !== item.id);
        return { requiredActions: [...list] };
      });
    }

    deleteRequiredActionByGroup = (group) => {
      this.setState(s => {
        const list = (s.requiredActions || []).filter((item) => group !== item.group);
        return { requiredActions: [...list] };
      });
    }

    onPanelSelect = (activeForm) => {
      this.setState({ activeForm });
    }

    events = [];
    onSaveClick = (form, handleSave) => {
      this.events.push({ form, handleSave });
    }

    removeEvent = (form) => {
      this.events = this.events.filter(e => e.form !== form);
    }

    hasFastrackFlow = () => {
      const queryParams = new URLSearchParams(this.props.location.search);
      const redirectBackToFastrack = queryParams.get('redirectBackToFastrack');
      if (redirectBackToFastrack) return true;
    }

    redirectToFastrackPageIfNeeded = () => {
      const { turingProfileCompleted = false } = this.props.store.tests || {};

      if (turingProfileCompleted) {
        redirectToFastrack();
      }
    }

    redirectToVetsmithPageIfNeeded = () => {
      const data = this.state.vetsmithFlowData;
      const completed = data.vetsmith_selected_flow
      const flow_id = data.flow_id;
      const flow_step_id = data.custom_profile_questions.flow_step_id;

      if (flow_id && flow_step_id) {
        axios.post(ApiConstant.BASE_URL + ApiConstant.MARK_VETSMITH_STEP_COMPLETE_FOR_DEV, {
          flow_id,
          flow_step_id
        }).then(res => {
          localStorage.removeItem('vetsmith_referred_for_profile_update');
          localStorage.setItem('vetsmith_selected_flow', flow_id);
          this.props.history.push(PageConstant.VETSMITH_PAGE);
        });
      }
    }

    save = async (form, isAutoSave = false, showSuccessAlerts = true) => {
      if (this.props.isEmbed && (isAutoSave || this.props.isReadOnly)) return Promise.resolve(true);
      const listPromises = this.events
        .filter(event => !form || event.form === form)
        .map(event => event.handleSave(isAutoSave));
      if (!isAutoSave) this.setState({ loading: true });

      if (!isAutoSave) {
        this.redirectToFastrackPageIfNeeded();

        if (this.state.vetsmithFlowData && !isAutoSave) {
          this.redirectToVetsmithPageIfNeeded();
        }
      }

      return Promise.all(listPromises)
        .then(list => {
          const success = list.every(result => !!result);
          if (success) {
            if (!isAutoSave && showSuccessAlerts) {
              this.setState({ saved: true });
              setTimeout(() => {
                this.setState({ saved: false });
              }, 2000);
            }
            if (showSuccessAlerts && list.find(result => !!result && result !== true)) {
              message.success('Successfully saved.', 1);
            }
            this.loadData(list, ({ completeSections, incompleteSections }) => {
              localStorage.setItem('RESUME_BUILDER_COMPLETED', JSON.stringify({ completeSections, incompleteSections }));
            }, isAutoSave);
          } else if (!isAutoSave) {
            setTimeout(() => {
              const errField = document.querySelector('.has-error');
              if (errField) errField.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
            }, 500);
          }
          return success;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          if (!localStorage.getItem('RESUME_BUILDER_SAVED')) {
            localStorage.setItem('RESUME_BUILDER_SAVED', '1');
            pushLog2DV2LogServer.info('RESUME_BUILDER_SAVED', 'RESUME_BUILDER_SAVED', {}, {});
          }
          window.dispatchEvent(new Event('vetting-refresh'));
          if (!isAutoSave) this.setState({ loading: false });
        });
    }

    getVetsmithFlowData = () => {
      const flowInfo = JSON.parse(localStorage.getItem("vetsmith_referred_for_profile_update"));
      let flowId = null;
      if (flowInfo) {
        flowId = flowInfo.flow_id;
      }
      if (flowId) {
        axios.get(ApiConstant.BASE_URL + ApiConstant.GET_VETSMITH_FLOW_DATA + `/${flowId}`)
          .then(res => {
            this.setState({
              vetsmithFlowData: res.data.data
            })
          });
      }
    }

    handleUpdateAvatar = (data) => {
      this.setState({ loading: true });
      this.props.dispatch(ProfileActions.UPDATE_AVATAR(data, () => this.loadData(['PersonalInformation'])));
    }

    handleUpdatePersonalInformation = (data, isAutoSave) => {
      return new Promise((resolve) => {
        this.props.dispatch(ProfileActions.UPDATE_PROFILE_DATA(data, (success) => {
          resolve(success);
        }, isAutoSave));
      });
    }

    updateEducation = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_CHANGES, {
        addedItems: [],
        deletedItems: [],
        updatedItems: [item]
      });
    }

    addEducation = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_CHANGES, {
        addedItems: [item],
        deletedItems: [],
        updatedItems: []
      });
    }

    deleteEducation = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_EDUCATION_CHANGES, {
        addedItems: [],
        deletedItems: [item],
        updatedItems: []
      });
    }

    updatePublication = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATIONS_CHANGES, {
        addedItems: [],
        deletedItems: [],
        updatedItems: [item]
      });
    }

    updateCloudCertification = (item) => {
      const formData = new FormData();
      Object.keys(item).forEach(e => e !== 'id' && formData.append(e, item[e] !== null ? item[e] : ''));
      return axios.put(`${ApiConstant.BASE_URL}${ApiConstant.SAVE_CLOUD_CERTIFICATION_CHANGES}/${item.id}`, formData);
    }

    addCloudCertification = (item) => {
      const formData = new FormData();
      Object.keys(item).forEach(e => formData.append(e, item[e]));
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CLOUD_CERTIFICATION_CHANGES, formData);
    }

    deleteCloudCertification = (item) => {
      return axios.delete(`${ApiConstant.BASE_URL}${ApiConstant.SAVE_CLOUD_CERTIFICATION_CHANGES}/${item.id}`);
    }

    addPublication = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATIONS_CHANGES, {
        addedItems: [item],
        deletedItems: [],
        updatedItems: []
      });
    }

    deletePublication = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_PUBLICATIONS_CHANGES, {
        addedItems: [],
        deletedItems: [item],
        updatedItems: []
      });
    }

    updateCertification = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, {
        addedItems: [],
        deletedItems: [],
        updatedItems: [item]
      });
    }

    addCertification = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, {
        addedItems: [item],
        deletedItems: [],
        updatedItems: []
      });
    }

    deleteCertification = (item) => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_CERTIFICATIONS_CHANGES, {
        addedItems: [],
        deletedItems: [item],
        updatedItems: []
      });
    }

    onWarningConfirm = () => {
      this.hideSkillFromRequiredAction();
      this.closeWarning();
    }

    closeWarning = () => {
      this.setState({ showWarning: false, currentSkill: null });
    }

    checkURLToOpenSection = () => {
      var urlParams = queryString.parse(window.location.search);
      if (urlParams && urlParams.wh) {
        this.onPanelSelect('WorkHistory');
      }
    }

    validateResume = async (file) => {
      const validExtensions = ['pdf', 'doc', 'docx'];
      const fileExtension = file.name.split('.').pop();
      return validExtensions.includes(fileExtension);
    }

    uploadResumeFile = async (file, replaceData = false) => {
      try {
        if (!this.validateResume(file)) throw new Error('Unacceptable file type');
        this.setState({ unmappedResumeData: [] });
        await saveResume(file, false, replaceData);
        await getParsedResumeData();
        // await this.getInfoParsedFromResumeData();
        await this.loadData(['PersonalInformation', 'WorkHistory', 'SideProjects', 'Education', 'Publications', 'Certifications', 'CloudCertifications'], this.checkURLToOpenSection);
      } catch (e) {
        console.error('Error uploading resume', e);
      }
      return true;
    }

    clearCurrentResumeData = () => {
      return axios.post(ApiConstant.BASE_URL + ApiConstant.REPLACE_SAVED_RESUME_DATA);
    }

    render () {
      const {
        resumeUpload: {
          loading: resumeLoading = false,
        } = {},
      } = this.props.store || {};
      const spinner = this.state.loading || resumeLoading;
      const { mcq_use_apiv1, $flagsReady } = this.props.LDFlags || {};
      return (
        <Spin spinning={spinner}>
          {$flagsReady && (
            <>
              <Component service={this} mcq_use_apiv1={mcq_use_apiv1} />
              <Modal wrapClassName='confirm-modal' width="500px" visible={this.state.showWarning} okText="Confirm" onOk={this.onWarningConfirm} onCancel={this.closeWarning}>
                {this.state.currentSkill
                  ? (
                    <Row>
                      <Col style={{ marginBottom: '32px' }}>
                        <Typography.Text className='confirm-title'>No experience in {this.state.currentSkill.skill_name}</Typography.Text>
                      </Col>
                      <Col style={{ marginBottom: '8px' }}>
                        <Typography.Text className='confirm-description'>We can&apos;t match you for this skill if you don&apos;t have enough experience in your profile.</Typography.Text>
                      </Col>
                    </Row>
                  )
                  : null}
              </Modal>
            </>)}
        </Spin>
      );
    }
  }

  const mapStateToProps = (store) => ({ store });
  const mapDispatchToProps = (dispatch) => ({ dispatch });

  FinalizeResumeV2Service.propTypes = {
    store: PropTypes.object,
    history: PropTypes.any,
    location: PropTypes.any,
    isEmbed: PropTypes.any,
    isReadOnly: PropTypes.any,
    dispatch: PropTypes.func,
    LDFlags: PropTypes.object
  };

  return connect(mapStateToProps, mapDispatchToProps)(withRouter(withLDFlagsFromBackend(FinalizeResumeV2Service, [
    GB_FLAGS.mcq_use_apiv1,
  ])));
}

export default withFinalizeResumeV2Service;
